import { jsx as n } from "react/jsx-runtime";
import e from "react";
const t = {
  ripple: !0,
  tooltip: {
    align: "top",
    showArrow: !1,
    activateOn: ["hover", "focus"],
    enterDelay: 0,
    leaveDelay: 0
  },
  typography: {},
  icon: {
    icon: "",
    basename: "material-icons",
    prefix: "",
    strategy: "auto",
    render: void 0
  }
}, p = {
  defaultTag: "span"
}, o = e.createContext(t), c = () => e.useContext(o), l = ({ children: r, ...a }) => /* @__PURE__ */ n(
  o.Provider,
  {
    value: {
      ...t,
      ...a
    },
    children: r
  }
);
export {
  o as ProviderContext,
  l as RMWCProvider,
  p as typographyDefaults,
  c as useProviderContext
};
